import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { InsideSection } from './components/InsideSection';
import { TransformationSection } from './components/TransformationSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="w-full bg-navy-900 font-sans" data-id="element-0" data-mp="31aqf2ee30qq7">
      <Hero data-id="element-1" data-mp="31bi8bik7icdb" />
      <main data-id="element-2" data-mp="31c1j8fbfw0hu">
        <ProblemSection data-id="element-3" data-mp="31ctaxf1x1e2u" />
        <SocialProofSection data-id="element-4" data-mp="2wka0gqyiyz29" />
        <InsideSection data-id="element-5" data-mp="2wiyvwox99na3" />
        <TransformationSection data-id="element-6" data-mp="2wip54z4dzc3c" />
        <SolutionSection data-id="element-7" data-mp="28ufoebm15ej2" />
        <FAQSection data-id="element-8" data-mp="28tmdqzjya4vn" />
        <FinalCTASection data-id="element-9" data-mp="28t4j27cxrypu" />
      </main>
      <SiteFooter data-id="element-10" data-mp="28s30zixi6bym" />
    </div>;
}